import { useEffect, useState } from "react";
import { storeStatus } from "@/lib/store";

export const StoreStatus = ({ testid = "store-status", className = "" }) => {
  const [status, setStatus] = useState(storeStatus);
  useEffect(() => {
    const t = setInterval(() => setStatus(storeStatus()), 60000);
    return () => clearInterval(t);
  }, []);
  return (
    <span data-testid={testid} data-open={status.open} className={`inline-flex items-center gap-2 text-sm ${className}`}>
      <span className="relative flex h-2 w-2">
        {status.open && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${status.open ? "bg-emerald-400" : "bg-zinc-400"}`} />
      </span>
      <span className={status.open ? "text-emerald-400 font-medium" : "text-zinc-300"}>{status.text}</span>
    </span>
  );
};
